import React, { useState, useEffect } from 'react';
import { UserPlus, UserMinus } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

export const FollowButton = ({ userId, username, size = 'sm', currentUser }) => {
  const [isFollowing, setIsFollowing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Don't show follow button for own profile
  if (!currentUser || userId === currentUser.id) {
    return null;
  }

  useEffect(() => {
    checkFollowStatus();
  }, [userId]);

  const checkFollowStatus = async () => {
    try {
      const response = await axios.get(`/users/${userId}/is-following`);
      setIsFollowing(response.data.is_following);
    } catch (error) {
      console.error('Error checking follow status:', error);
    }
  };

  const handleFollow = async (e) => {
    e.stopPropagation();
    setIsLoading(true);

    try {
      if (isFollowing) {
        await axios.delete(`/users/${userId}/unfollow`);
        setIsFollowing(false);
        toast.success(`Unfollowed @${username}`);
      } else {
        await axios.post(`/users/${userId}/follow`);
        setIsFollowing(true);
        toast.success(`Following @${username}`);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update follow status');
    } finally {
      setIsLoading(false);
    }
  };

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
  };

  return (
    <button
      onClick={handleFollow}
      disabled={isLoading}
      className={`${sizeClasses[size]} font-semibold rounded-lg border transition-all ${
        isFollowing
          ? 'bg-voteDefault text-grayMeta border-cardBorder hover:bg-voteDown-bg hover:text-voteDown-text'
          : 'bg-primary text-primaryDark border-primary hover:bg-primary/90'
      } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <span className="flex items-center gap-1">
        {isFollowing ? (
          <>
            <UserMinus className="w-3 h-3" />
            Following
          </>
        ) : (
          <>
            <UserPlus className="w-3 h-3" />
            Follow
          </>
        )}
      </span>
    </button>
  );
};
